import { useState } from "react";
import { Stack } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "./ui/dialog";
import { api } from "../lib/api";

export const SaveAsTemplateButton = ({ planId, versionNumber, defaultName, dirty }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleOpen = (v) => {
    if (v) { setName(defaultName); setDescription(""); }
    setOpen(v);
  };

  const handleSave = async () => {
    if (!name.trim()) { toast.error("Ingresa un nombre"); return; }
    try {
      await api.templateFromVersion(planId, versionNumber, { name, description });
      toast.success(`Plantilla "${name}" creada desde V${versionNumber}`);
      setOpen(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al crear plantilla");
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpen}>
      <DialogTrigger asChild>
        <Button data-testid="save-as-template-btn" variant="outline" className="rounded-sm" title="Guardar como plantilla">
          <Stack size={16} weight="bold" className="mr-2" /> Plantilla
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="save-as-template-dialog" className="rounded-sm max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl font-extrabold tracking-tight">
            Guardar V{versionNumber} como plantilla
          </DialogTitle>
        </DialogHeader>
        {dirty && (
          <p className="text-xs text-amber-700 dark:text-amber-300" data-testid="save-as-template-dirty-warning">
            Tienes cambios sin guardar: la plantilla usará la V{versionNumber} guardada.
          </p>
        )}
        <div className="space-y-4 py-2">
          <div>
            <Label className="label-xs text-muted-foreground">Nombre de la plantilla</Label>
            <Input data-testid="save-as-template-name-input" value={name}
              onChange={(e) => setName(e.target.value)} className="mt-1 rounded-sm" />
          </div>
          <div>
            <Label className="label-xs text-muted-foreground">Descripción (opcional)</Label>
            <Textarea data-testid="save-as-template-description-input" rows={2} value={description}
              onChange={(e) => setDescription(e.target.value)} className="mt-1 rounded-sm" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="confirm-save-as-template-btn" onClick={handleSave} className="rounded-sm font-semibold">
            Crear Plantilla
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
